// Formatação pt-BR compartilhada (docs/specs/standards/copy-and-i18n.md).
// Único lugar que instancia Intl.NumberFormat para moeda: antes eram ~20
// cópias inline com semânticas levemente diferentes (`v` vs `v || 0`).

const BRL = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
const BRL_COMPACT = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  maximumFractionDigits: 0,
});

/**
 * "R$ 1.234,56". `null`/`undefined`/`NaN` viram R$ 0,00 (todo consumidor
 * tratava ausência como zero). `compact` tira os centavos — para KPI grande.
 */
export function formatBRL(value: number | null | undefined, opts?: { compact?: boolean }): string {
  const n = typeof value === "number" && Number.isFinite(value) ? value : 0;
  return (opts?.compact ? BRL_COMPACT : BRL).format(n);
}
